'use client';

import { CommonFooter as CommonCommonFooter, type FooterMenuItem } from '@monorepo/common';
import type { Session } from 'next-auth';

function CommonFooter({
  siteName,
  copyright,
  sessionData,
}: {
  siteName: string;
  copyright: string;
  sessionData?: Session | null;
}) {
  // toはサイト内リンク、hrefは外部リンク
  const menuListLeft: Array<FooterMenuItem> = sessionData?.user
    ? [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?tab=is_session', text: '開催中のくじ一覧' },
        { to: '/faq', text: 'よくある質問' },
        { to: '/contact', text: 'お問い合わせ' },
        { to: '/informations', text: 'お知らせ' },
        { to: '/keihin', text: '景品のお取り扱いについての注意事項' },
      ]
    : [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?tab=is_session', text: '開催中のくじ一覧' },
        { to: '/faq', text: 'よくある質問' },
        { to: '/informations', text: 'お知らせ' },
        { to: '/keihin', text: '景品のお取り扱いについての注意事項' },
      ];

  const menuListRight: Array<FooterMenuItem> = [
    { to: '/terms', text: '利用規約' },
    {
      href: 'https://fogg.jp/privacy',
      text: '個人情報保護方針',
    },
    { to: '/policy', text: '個人情報の取扱いについて' },
    { to: '/tokusho', text: '特定商取引法に基づく表記' },
    { to: '/shikin', text: '資金決済法に基づく表記' },
  ];

  return (
    <CommonCommonFooter
      siteName={siteName}
      copyright={copyright}
      menuListLeft={menuListLeft}
      menuListRight={menuListRight}
    />
  );
}

export default CommonFooter;
